




























import { Watch, Component, Prop, Vue } from 'vue-property-decorator'
import { OrderAPI } from '@/api/backend-client'
import { Order } from '@/api/model/order'
import KvButton from '@/components/input/KvButton.vue'
import IconWarning from '@/components/icons/IconWarning.vue'
import Modal from '@/components/ui/Modal.vue'
import { namespace } from 'vuex-class'
import { ReferralFilterDirection, ReferralView } from '@/api/types'
import { escapeHtml } from '@/helpers/html'
const orders = namespace('orders')

@Component({
    components: {
        Modal,
        IconWarning,
        KvButton,
    },
})
export default class DeleteOrderModal extends Vue {
    @orders.State view!: ReferralView
    @orders.State direction!: ReferralFilterDirection
    @orders.Action applyView!: ({ view: ReferralView, direction: ReferralFilterDirection }) => Promise<void>
    @Prop({ required: true }) readonly order!: Order
    @Prop({ type: Boolean, default: false }) value!: boolean
    visible: boolean = false
    loading: boolean = false

    @Watch('value')
    onValueChanged(): void {
        this.visible = this.value
    }

    @Watch('visible')
    onVisibleChanged(): void {
        this.$emit('input', this.visible)
    }

    async deleteOrder(): Promise<void> {
        this.loading = true

        try {
            await OrderAPI.delete(this.order.id)
            this.$notify({
                type: 'success',
                text: this.$t('order.deleteSuccess').toString(),
            })

            await this.$router.push({name: 'orders_all'})
            await this.applyView({
                view: this.view,
                direction: this.direction,
            })

        } catch (error) {
            this.$notify({
                type: 'error',
                title: 'Foutmelding',
                text: escapeHtml(error.message),
            })
        }

        this.loading = false
        this.$emit('on-save', true)
    }
}
